import { render, staticRenderFns } from "./Pushs.vue?vue&type=template&id=055093c0&scoped=true&"
import script from "./Pushs.vue?vue&type=script&lang=js&"
export * from "./Pushs.vue?vue&type=script&lang=js&"
import style0 from "./Pushs.vue?vue&type=style&index=0&id=055093c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055093c0",
  null
  
)

export default component.exports